import { getDefaultState } from "../utils/index";

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    LOGIN_START(state) {
      state.loading = true;
    },
    LOGIN_FAILED(state, error) {
      state.loading = false;
      state.error = error;
    },
    LOGIN_SUCCESS(state, user) {
      window.localStorage.setItem("clickedLogout", "false");
      (state.error = ""),
        (state.loading = false),
        (state.error = ""),
        (state.token = user.status),
        (state.user = user.data);
    },

    SIGNUP_START(state) {
      state.loading = true;
    },
    SIGNUP_FAILED(state, error) {
      state.loading = false;
      state.error = error;
    },
    SIGNUP_SUCCESS(state, user) {
      (state.loading = false),
        (state.error = ""),
        (state.token = user.status),
        (state.success = user.message),
        (state.user = user.data);
    },

    FORGOT_PASSWORD_START(state) {
      state.loading = true;
    },
    FORGOT_PASSWORD_FAILED(state, error) {
      state.loading = false;
      state.error = error;
    },
    FORGOT_PASSWORD_SUCCESS(state, user) {
      (state.loading = false),
        (state.error = ""),
        (state.status = user.status),
        (state.success = user.message);
    },

    LOGOUT_SUCCESS(state) {
      window.localStorage.removeItem("readycash-report");
      Object.assign(state, getDefaultState());
    },
  },

  actions: {
    async login({ commit }, payload) {
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      try {
        commit("LOGIN_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/auth/login`,
          config
        );

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }

        const user = await response.json();
        commit("LOGIN_SUCCESS", user);
      } catch (err) {
        console.log(err);
        commit("LOGIN_FAILED", err.message);
      }
    },

    async signup({ commit }, payload) {
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      try {
        commit("SIGNUP_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/auth/register`,
          config
        );

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }

        const user = await response.json();
        commit("SIGNUP_SUCCESS", user);
      } catch (err) {
        commit("SIGNUP_FAILED", err.message);
      }
    },

    async forgotPassword({ commit }, payload) {
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      try {
        commit("FORGOT_PASSWORD_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/auth/forgot-password`,
          config
        );

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }

        const user = await response.json();
        commit("FORGOT_PASSWORD_SUCCESS", user);
      } catch (err) {
        commit("FORGOT_PASSWORD_FAILED", err.message);
      }
    },

    async logout({ commit }) {
      commit("LOGOUT_SUCCESS");
    },
  },
};
